module.exports = __webpack_public_path__ + "img/lazada.ddf73c0.png";